module.exports = __webpack_public_path__ + "static/media/3 surrealism botanical laeves female portrait.1280x1707.fd33865f.webp";